module.exports = __webpack_public_path__ + "static/media/preview-letter.c8878cd3.svg";